import moment from 'moment'
import {
  checkIsDataUpdated,
  checkIsDataUpdatedInLog,
  checkIsFieldHide,
  getFieldsAndLabelByTab,
  getTabNameForLogs,
  getValueByFieldTypeNid,
} from '../../../../Pages/Logs/logHelper'
import { primary_color } from '../../../../Helper/uiHelper'

const ShowDifference = ({ data, original_data, updated_data, onExpand, difference, parentPageName, fields, tab_name }) => {
  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i class='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className={`permission-header`} style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {` has updated data in `}
              <span className='font-weight-bold'>{'Email'}</span>
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='p-4'>
          <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }}>
            <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
              Title:
            </div>
            <div style={{ width: '30%' }}>{updated_data?.title}</div>
            {updated_data?.title !== original_data?.title && (
              <div style={{ width: '30%' }} className={`${'p-2 bg-danger text-light'}`}>
                {original_data?.title}
              </div>
            )}
          </div>
          <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }}>
            <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
              Message:
            </div>
            <div style={{ width: '30%' }} dangerouslySetInnerHTML={{ __html: updated_data?.title }}></div>
            {updated_data?.message !== original_data?.message && (
              <div
                style={{ width: '30%' }}
                className={`${'p-2 bg-danger text-light'}`}
                dangerouslySetInnerHTML={{ __html: original_data?.message }}></div>
            )}
          </div>
          <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }}>
            <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
              Send After:
            </div>
            <div style={{ width: '30%' }}>{updated_data?.send_renewal_email_after}</div>
            {updated_data?.send_renewal_email_after !== original_data?.send_renewal_email_after && (
              <div style={{ width: '30%' }} className={`${'p-2 bg-danger text-light'}`}>
                {original_data?.send_renewal_email_after}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const RenewalEmailUpdate = ({ data, onExpand, expandedId, parentPageName }) => {
  let updated_data = data?.updated_data && JSON.parse(data?.updated_data)
  let original_data = data?.original_data && JSON.parse(data?.original_data)
  let tab_name = getTabNameForLogs(parentPageName, data?.tab_name)
  const fields = getFieldsAndLabelByTab(parentPageName, data?.tab_name)

  if (expandedId) {
    return (
      <ShowDifference
        data={data}
        tab_name={tab_name}
        updated_data={updated_data}
        original_data={original_data}
        fields={fields}
        onExpand={onExpand}></ShowDifference>
    )
  }
  // if (!checkIsDataUpdatedInLog(original_data, updated_data, fields)) return
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          class='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {` has updated data in `}
        <span className='font-weight-bold'>{'Email'}</span>
      </div>
      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default RenewalEmailUpdate
